import { render, staticRenderFns } from "./DiscountPopinInfoShared.vue?vue&type=template&id=3dab1d9d"
import script from "./DiscountPopinInfoShared.vue?vue&type=script&lang=ts"
export * from "./DiscountPopinInfoShared.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports